import styled from 'styled-components'

import { COLORS, THEME, typeScale, typography, hasTheme } from '../../styles'

const Styled = styled.div`
  padding: 1.6rem 2.4rem 0;
`
Styled.tagsTable = styled.table`
  width: 100%;
`
Styled.tags = styled.tbody`
  width: 100%;
`
Styled.tagUnit = styled.td`
  ${typography({
    fontFamily: ['Viksjow', 'Surt', 'sans-serif'],
    fontSize: '1.7rem',
    lineHeight: 'normal',
  })};
  padding: 1.6rem 0;
  text-align: left;
  border-bottom: 0;
`
Styled.tagLabel = styled.td`
  padding: 1.6rem 0;
  text-align: right;
  border-bottom: 0;
`
Styled.tag = styled.tr`
  color: ${({ $isActive }) =>
    $isActive ? COLORS.cobalt : THEME.COLORS.foreground.primary};
  border-bottom: dashed 0.1rem ${THEME.COLORS.foreground.tertiary};

  ${({ $isActive }) => hasTheme('dark')`
    color: ${$isActive ? COLORS.cobalt : COLORS.black};
    border-bottom: dashed 0.1rem ${COLORS.black};
  `}

  &:first-child {
    ${Styled.tagUnit}, ${Styled.tagLabel} {
      padding-top: 0;
    }
  }

  &:last-child {
    border-bottom: 0;
  }
`
Styled.footnote = styled.p`
  ${typeScale('caption')};
  padding-top: 0.4rem;
  text-align: center;
  color: ${THEME.COLORS.foreground.secondary};

  ${hasTheme('dark')`
    color: ${COLORS.black};
  `}
`

export default Styled
